module.exports = __webpack_public_path__ + "img/guQuanJiaGouTuEn.a57333e0.png";